export default "__VITE_ASSET__Xx7GwIWC__"